import Link from '@amzn/meridian/link';
import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import mailImage from '../../../assets/WelcomeLetterImage.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpBody, HelpImage, HelpStep, HelpTitle } from './HelpElements';

const UserSetupHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('userSetupHelp');

    return (
        <>
            <HelpTitle>{t('userSetupHelp_Title')}</HelpTitle>
            <HelpBody>
                <Trans
                    i18nKey={'userSetupHelp_purpose'}
                    ns={'userSetupHelp'}
                    components={{
                        url: <Link href={'https://reseller.amazon.com/'}>{''}</Link>,
                    }}
                />
            </HelpBody>
            <HelpStep step={1}>
                <Trans
                    i18nKey={'userSetupHelp_accountManagerInvite'}
                    ns={'userSetupHelp'}
                    components={{
                        url: <Link href={'https://reseller.amazon.com/'}>{''}</Link>,
                    }}
                />
            </HelpStep>
            <HelpStep step={2}>
                <Trans
                    i18nKey={'userSetupHelp_inviteEmailReceive'}
                    ns={'userSetupHelp'}
                    components={{
                        url1: <Link href={'https://reseller.amazon.com/'}>{''}</Link>,
                        url2: <Link href={'https://reseller.amazon.com/account/sign-in'}>{''}</Link>,
                    }}
                />
            </HelpStep>
            <HelpImage src={mailImage} size={'large'} />
            <HelpStep step={3}>{t('userSetupHelp_promptedToChangePassword')}</HelpStep>
        </>
    );
};

export { UserSetupHelp };
